import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

class RejectDialog extends Component {
  render() {
    const { t } = this.props;
    
    
    return(
      <div>
        <div className="modal fade" id="modalReject" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <h4>{t('dashboard.sdelivery.heading_reject')}</h4>
                <p>
                  {t('dashboard.sdelivery.reject_dialog')}
                </p>
                  <textarea rows="2" cols="60" id="reasonInput" placeholder={t('dashboard.sdelivery.reject_placeholder')} style={{width:'100%'}}></textarea>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-danger"
                  data-dismiss="modal"
                  type="button"
                  onClick={
                    ()=>{ $('#btnReject').click(); }
                  }
                >
                  {t('dashboard.sdelivery.dialog_btn_reject')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(RejectDialog);



// WEBPACK FOOTER //
// ./src/dashboard/sdelivery/RejectDialog.js